export * from 'ringcentral-integration/enums/phoneSources';

// Don't use this anymore.
// We keep this only for 3rd-party compatible.
// Use "ringcentral-js-widgets/ringcentral-integration/enums/phoneSources.ts" instead.
